<div class="app-menu navbar-menu">
  <!-- LOGO -->
  <div class="navbar-brand-box">
    <a routerLink="/" class="logo logo-dark">
      <span class="logo-sm">
        <img src="assets/images/logo-sm-dark.svg" alt="" height="26" />
      </span>
      <span class="logo-lg">
        <img src="assets/images/logo-light.svg" alt="" height="26" />
      </span>
    </a>
    <a routerLink="/" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/logo-sm-light.svg" alt="" height="24" />
      </span>
      <span class="logo-lg">
        <img src="assets/images/logo-dark.svg" alt="" height="24" />
      </span>
    </a>
    <button
      type="button"
      class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
      id="vertical-hover"
    >
      <i class="ri-record-circle-line"></i>
    </button>
  </div>

  <div id="scrollbar">
    <div class="container-fluid">
      <div id="two-column-menu"></div>

      <ul class="navbar-nav" id="navbar-nav">
        <!-- Перебираем элементы меню -->
        <ng-container *ngFor="let item of menuItems">
          <!-- Если это заголовок -->
          <li class="menu-title" *ngIf="item.isTitle">
            <span>{{ item.label | translate }}</span>
          </li>

          <!-- Если это не заголовок и не layout -->
          <li class="nav-item" *ngIf="!item.isTitle && !item.isLayout">
            <!-- Если у пункта есть вложенные subItems -->
            <ng-container *ngIf="hasItems(item); else simpleLink">
              <a
                href="javascript:void(0);"
                class="is-parent nav-link ps-2 ms-2 menu-link"
                data-bs-toggle="collapse"
                aria-expanded="false"
              >
                <i class="{{ item.icon }} icon nav-icon" *ngIf="item.icon"></i>
                <span>{{ item.label | translate }}</span>
                <span
                  class="badge badge-pill {{ item.badge.variant }}"
                  *ngIf="item.badge"
                >
                  {{ item.badge.text | translate }}
                </span>
              </a>
              <div class="collapse menu-dropdown" id="sidebarDashboards">
                <ul class="nav nav-sm flex-column" aria-expanded="false">
                  <!-- 2-й уровень -->
                  <li
                    class="nav-item"
                    *ngFor="let subitem of item.subItems; let si = index"
                  >
                    <!-- Если subitem тоже имеет subItems -->
                    <ng-container *ngIf="hasItems(subitem); else subitemLink">
                      <a
                        class="nav-link"
                        href="javascript:void(0);"
                        data-bs-toggle="collapse"
                        aria-expanded="false"
                        (click)="toggleSubItem($event)"
                      >
                        <i
                          class="{{ subitem.icon }} icon nav-icon"
                          *ngIf="subitem.icon"
                        ></i>
                        {{ subitem.label | translate }}
                      </a>
                      <div class="collapse menu-dropdown">
                        <ul
                          class="nav nav-sm flex-column"
                          aria-expanded="false"
                        >
                          <!-- 3-й уровень -->
                          <li
                            class="nav-item"
                            *ngFor="let subSubitem of subitem.subItems"
                          >
                            <!-- Если у subSubitem есть ещё childItem -->
                            <ng-container
                              *ngIf="subSubitem.childItem; else subSubLink"
                            >
                              <a
                                class="nav-link"
                                [routerLink]="subSubitem.link"
                                (click)="updateActive($event)"
                                aria-expanded="false"
                              >
                                <i class="{{ subSubitem.icon }} icon nav-icon" *ngIf="subSubitem.icon"></i>
                                {{ subSubitem.label | translate }}
                              </a>
                              <div class="collapse menu-dropdown">
                                <ul
                                  class="nav nav-sm flex-column"
                                  aria-expanded="false"
                                >
                                  <!-- 4-й уровень -->
                                  <li
                                    class="nav-item"
                                    *ngFor="let subChilditem of subSubitem.childItem"
                                  >
                                    <a
                                      class="nav-link"
                                      [routerLink]="subChilditem.link"
                                      (click)="updateActive($event)"
                                    >
                                      <i class="{{ subChilditem.icon }} icon nav-icon" *ngIf="subChilditem.icon"></i>
                                      {{ subChilditem.label | translate }}
                                    </a>
                                    <!-- Ещё уровень, если надо -->
                                  </li>
                                </ul>
                              </div>
                            </ng-container>

                            <!-- Если у subSubitem нет childItem -->
                            <ng-template #subSubLink>
                              <a
                                class="nav-link"
                                [routerLink]="subSubitem.link"
                                (click)="updateActive($event)"
                              >
                                <i class="{{ subSubitem.icon }} icon nav-icon" *ngIf="subSubitem.icon"></i>
                                {{ subSubitem.label | translate }}
                              </a>
                            </ng-template>
                          </li>
                        </ul>
                      </div>
                    </ng-container>

                    <!-- Если subitem не имеет вложений -->
                    <ng-template #subitemLink>
                      <a
                        class="nav-link"
                        [routerLink]="subitem.link"
                        (click)="updateActive($event)"
                      >
                        <i
                          class="{{ subitem.icon }} icon nav-icon"
                          *ngIf="subitem.icon"
                        ></i>
                        {{ subitem.label | translate }}
                      </a>
                    </ng-template>
                  </li>
                </ul>
              </div>
            </ng-container>

            <!-- Если у пункта нет вложенных subItems -->
            <ng-template #simpleLink>
              <a
                [routerLink]="item.link"
                class="side-nav-link-ref nav-link menu-link"
                [routerLinkActive]="'active'"
                (click)="updateActive($event)"
              >
                <i class="{{ item.icon }} icon nav-icon" *ngIf="item.icon"></i>
                <span>{{ item.label | translate }}</span>
                <span
                  class="badge {{ item.badge.variant }} float-end"
                  *ngIf="item.badge"
                >
                  {{ item.badge.text | translate }}
                </span>
              </a>
            </ng-template>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>

  <div class="sidebar-background"></div>
</div>

<!-- Вертикальный оверлей, если используется -->
<div class="vertical-overlay"></div>
